"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InappStore = void 0;
const http_1 = require("@completeanatomy/http");
const store_1 = require("@completeanatomy/store");
const components_1 = require("../components");
require("reflect-metadata");
const typedi_1 = require("typedi");
let InappStore = class InappStore {
    constructor(http, store) {
        this.http = http;
        this.store = store;
    }
    sendSubscriptionAddedToCartEvent(license) {
        return __awaiter(this, void 0, void 0, function* () {
            const user = this.store.getState().currentUser;
            const device = this.store.getState().deviceInformation;
            const devicePlatform = device === null || device === void 0 ? void 0 : device.platform;
            const storePlatform = (0, components_1.getStorePlatform)(devicePlatform);
            const unixTimestamp = Math.floor(new Date().getTime() / 1000);
            const cartData = {
                email: user === null || user === void 0 ? void 0 : user.email,
                userId: user === null || user === void 0 ? void 0 : user.auth0_id,
                eventName: 'subscriptionAddedToCart',
                createdAt: unixTimestamp,
                dataFields: {
                    bundle: license.identifier,
                    devicePlatform: storePlatform,
                },
            };
            if (user) {
                const response = yield this.http.post({
                    path: 'events/',
                    data: cartData,
                    backend: http_1.Backend.SSO,
                    apiPrefix: http_1.APIPrefix.None,
                });
                if (!response.ok) {
                    console.warn('Failed to post sendSubscriptionAddedToCart event.', response);
                }
                return response.json();
            }
            return;
        });
    }
};
exports.InappStore = InappStore;
InappStore.exportName = 'inappStore';
exports.InappStore = InappStore = __decorate([
    (0, typedi_1.Service)(),
    __param(1, (0, typedi_1.Inject)(store_1.StoreToken)),
    __metadata("design:paramtypes", [http_1.HTTP, Object])
], InappStore);
